var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphoneGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M19.333 4.833L3.444 9.723v4.888l3.886 1.196a3.667 3.667 0 107.002 2.154l5.001 1.539V4.833zM10.778 18.89a1.833 1.833 0 01-1.691-2.542l3.486 1.073a1.836 1.836 0 01-1.795 1.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M22.389 3.611h-1.222a.61.61 0 00-.611.611v15.89c0 .337.273.61.61.61h1.223a.61.61 0 00.611-.61V4.221a.61.61 0 00-.611-.61zM2.222 8.5C1.547 8.5 1 9.047 1 9.722v4.89a1.222 1.222 0 002.444-.001V9.722c0-.675-.547-1.222-1.222-1.222z"
  }))));
}

export default SvgMegaphoneGray;